<script>
import _ from 'lodash'
// import utils from '@/lib/utils'
import { WordEntryState } from '@/lib/enums'
import { createNamespacedHelpers } from 'vuex'
import { QSelect } from 'quasar'
import FieldIconMixin from './FieldIconMixin.js'
import FieldProxyMixin from './FieldProxyMixin.js'
import FieldSelectMixin from './FieldSelectMixin.js'
import FieldDenseMixin from './FieldDenseMixin'
import IBtn from '../ext/IBtn.vue'

const { mapGetters, mapActions } = createNamespacedHelpers('bis/word')

export default {
  mixins: [FieldIconMixin, FieldProxyMixin, FieldSelectMixin, FieldDenseMixin],
  props: {
    word: {
      required: true,
      type: String
    },
    showAdd: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: String
    }
  },
  data () {
    return {
      selectOptions: null,
      inputValue: null,
      actions: {
        add: {
          loading: false,
          disable: false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getWordsOptionsByType', 'getWordIconByType', 'getWordLabelByType', 'getWordsListByType']),
    // override PrependIconMixin
    computedPrependIcon () {
      return this.prependIcon ?? this.getWordIconByType(this.word)
    },
    // override FieldSelectMixin
    allOptions () {
      // TODO: 是否响应式？
      if (this.sortBy) {
        const words = this.getWordsOptionsByType(this.word)
        words.sort((a, b) => {
          return Number(a.model.data[this.sortBy]) - Number(b.model.data[this.sortBy])
        })
        return words
      } else {
        return this.getWordsOptionsByType(this.word)
      }
    },
    computedLabel () {
      return this.label ?? this.getWordLabelByType(this.word)
    }
  },
  async created () {
    await this.loadWords()
    this.selectOptions = this.validOptions
  },
  render (createElement) {
    const useInput = this.useInput ?? true
    const label = this.computedLabel
    const inputValue = this.inputValue?.trim()
    const inputValueUpperCase = inputValue?.toUpperCase()
    const presetScopedSlots = {
      prepend: this.slotPrependIcon(createElement),
      option: this.slotOption(createElement),
      'selected-item': this.slotSelectedItem(createElement)
    }
    if (!this.disable && this.$refs.input) {
      if (this.showAdd && useInput && inputValue && this.selectOptions && !this.selectOptions.find(item => this.$refs.input.getOptionLabel(item)?.trim()?.toUpperCase() === inputValueUpperCase)) {
        const that = this
        presetScopedSlots.append = function () {
          return createElement(IBtn, {
            props: {
              glossy: false,
              round: true,
              dense: true,
              flat: true,
              icon: 'add_circle',
              tooltipText: `新增${label}(${inputValue})`,
              ...that.actions.add
            },
            on: {
              click () {
                if (inputValue) {
                  that.addWord(inputValue)
                }
              }
            }
          })
        }
      }
    }
    return createElement(QSelect, {
      ref: 'input',
      props: {
        ...this.$props,
        dense: this.computedDense,
        useInput: useInput,
        hideSelected: this.hideSelected ?? useInput,
        fillInput: this.fillInput ?? useInput,
        options: this.selectOptions,
        label: label,
        useChips: this.multiple,
        disable: false,
        readonly: this.disable || this.readonly
      },
      attrs: {
        ...this.$attrs
      },
      on: Object.assign({
        filter: (val, update) => {
          this.onFilterOptions(val, update)
        },
        'input-value': (val) => {
          this.inputValue = _.isNil(val) ? '' : String(val)
        }
      }, this.$listeners),
      scopedSlots: Object.assign(presetScopedSlots, this.$scopedSlots)
    })
  },
  methods: {
    ...mapActions(['loadWords']),
    async addWord (wordText) {
      if (!wordText) {
        this.$q.notify({ type: 'warning', message: `未指定待添加的新 ${this.computedLabel} 名称` })
        return
      }
      this.actions.add.loading = true
      this.actions.add.disable = true
      const sort = (_.max(this.allOptions, option => option.model?.sort ?? 0)?.model?.sort ?? 0) + 1
      let dataParam = null
      if (this.validOptions.length > 0) {
        dataParam = JSON.stringify(this.validOptions[0].model.data)
      }
      const result = await this.$$api.bis.put('/dic/wordEntry/', {
        type: this.word,
        text: wordText,
        state: WordEntryState.Enabled,
        builtinName: null,
        sort: sort,
        data: dataParam,
        remarks: null,
        appId: null
      })
      result.notify(result.success ? `新增${this.computedLabel}(${wordText})成功` : null)
      if (result.success) {
        await this.loadWords({ force: true })
        const emittingOptionValue = this.$refs.input.getEmittingOptionValue(result.data.id)
        console.log('emittingOptionValue', emittingOptionValue, result)
        this.$emit('input', emittingOptionValue)
      }
      this.actions.add.loading = false
      this.actions.add.disable = false
    }
  }
}
</script>
